<template>
  <div>
    <b-modal
      v-show="!modalLoads"
      id="modal-role"
      ok-only
      :ok-title="$t('DEBTIA_CLOSE')"
      centered
      :title="$t('DEBTIA_LOGS_DETAILS')"
      size="lg"
    >
      <b-overlay
        id="overlay-background"
        :show="modalLoads === true"
        variant="dark"
        opacity="0.85"
        blur="2px"
        rounded="sm"
        spinner-variant="primary"
        spinner-medium
      >
        <b-card
          no-body
          class="card-developer-meetup"
        >
          <b-card-body>
            <!-- metting header -->
            <div class="meetup-header d-flex align-items-center">
              <div class="meetup-day">
                <h3 class="mb-0">
                  {{ logDetails.created_at }}
                </h3>
              </div>
              <div class="my-auto">
                {{ $t('DEBTIA_FILENAME') }} :
                <a
                  :href="logDetails.pdf_link"
                  target="_blank"
                >
                  {{ logDetails.filename }}
                </a>
              </div>
            </div>
            <!--/ metting header -->
            <!-- media -->
            <b-media
              no-body
            >
              <b-media-body>
                <h6 class="mb-0">
                  {{ $t('DEBTIA_RECEIVERS') }}
                </h6>
                <small><a :href="'mailto:' + logDetails.email">{{ logDetails.email }}</a></small>
              </b-media-body>
            </b-media>
            <b-media
              no-body
            >
              <b-media-body>
                <h6 class="mb-0">
                  {{ $t('DEBTIA_SUBJECT') }}
                </h6>
                <small>{{ logDetails.subject ? logDetails.subject : 'N/A' }}</small>
              </b-media-body>
            </b-media>
            <b-media
              no-body
            >
              <b-media-body>
                <h6 class="mb-0">
                  {{ $t('DEBTIA_BODY') }}
                </h6>
                <!--  eslint-disable-next-line vue/no-v-html -->
                <small v-html="logDetails.body" />
              </b-media-body>
            </b-media>
          </b-card-body>
        </b-card>
      </b-overlay>
    </b-modal>
  </div>
</template>

<script>
import {
  BModal, BOverlay, BCard, BCardBody, BMedia, VBTooltip, BMediaBody,
} from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BOverlay,
    BCard,
    BCardBody,
    BMedia,
    BMediaBody,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    logData: {
      type: Object,
      required: true,
    },
    modalLoads: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {
      modalLoader: true,
      loader: true,
      logDetails: {},
      headingArray: [],
      to: '',
      cc: [],
      bcc: [],
      user_type: JSON.parse(localStorage.getItem('userData')).data.name,
    }
  },
  watch: {
    logData: {
      handler() {
        this.logDetails = { ...this.logData }
      },
    },
  },
}
</script>

<style>

</style>
